var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBgTexture(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 683 469",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.688 549.076S-18.228 457.831.318 385.419c20.434-79.785 69.565-102.342 105.241-123.777 45.982-27.617 71.525-65.463 88.895-127.864 17.37-62.402 67.099-110.131 121.23-124.447 68.757-18.174 120.566 9.202 148.153 52.167 27.587 42.966 36.128 106.756 95.391 133.323 59.264 26.566 98.431 36.143 115.802 87.283 17.37 51.141-15.326 114.563-28.607 147.325-13.281 32.761-28.613 95.133-12.262 130.932",
    stroke: "#F4F0F1",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.594 549.303s-41.6-67.88-30.345-136.436c11.254-68.557 57.291-81.863 91.035-108.47s76.394-70.9 90.691-119.385c20.112-68.218 46.913-92.3 80.119-99.597 41.938-9.21 89.671 18.761 109.106 71.969 19.435 53.208 24.549 72.658 68.527 91.074 43.978 18.417 85.807 26.318 107.403 81.863 14.316 36.845-10.263 96.19-29.662 147.381-12.848 33.825-22.503 67.535-18.415 89.026",
    stroke: "#F4F0F1",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M145.099 548.085s-23.521-40.923-24.522-84.913c-1.001-43.991 17.37-78.766 53.134-102.298 35.765-23.532 65.046-46.032 84.436-98.204 19.39-52.173 33.4-86.617 64.038-96.846 41.687-13.888 69.135 23.188 81.42 54.902 12.286 31.714 22.478 60.355 62.326 83.887 39.847 23.532 81.74 45.011 87.873 85.928 6.134 40.917-7.153 73.669-15.331 95.136s-15.325 40.923-20.433 66.496",
    stroke: "#F4F0F1",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M199.606 547.625s-25.473-33.635-24.457-70.325c1.017-36.691 14.268-61.152 48.913-80.511 31.067-17.367 48.907-43.837 58.08-74.398 11.109-37.045 23.957-64.526 51.969-70.325 29.551-6.112 55.024 16.309 65.213 51.977 10.189 35.668 28.535 49.932 58.086 69.303 29.551 19.371 48.913 41.786 47.89 77.454-1.022 35.668-22.417 74.398-30.568 95.802",
    stroke: "#F4F0F1",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M241.073 545.235s-12.281-24.515-12.281-49.025c0-24.509 13.29-44.949 37.866-56.182 24.575-11.232 37.866-31.666 41.962-59.244 4.096-27.579 13.291-51.075 34.797-53.113 21.507-2.038 29.681 12.258 34.798 36.779 5.117 24.522 11.254 34.729 27.632 42.905 16.378 8.176 38.893 11.233 44.01 33.704 5.117 22.472-1.027 36.78-13.29 52.094-12.264 15.315-25.585 30.648-16.372 57.201",
    stroke: "#F4F0F1",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M287.614 490.174c-6.081-21.678 35.339-44.457 57.586-48.378 22.247-3.92 41.878 11.767 41.878 30.072 0 18.306-15.888 25.466-31.408 30.073-23.73 7.033-58.02 23.954-68.056-11.767z",
    stroke: "#F4F0F1",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

export default SvgBgTexture;